import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/site/Hero";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { BrandMarquee } from "@/components/site/BrandMarquee";
import { About } from "@/components/site/About";
import { Offer } from "@/components/site/Offer";
import { Brands } from "@/components/site/Brands";
import { Why } from "@/components/site/Why";
import { Contact } from "@/components/site/Contact";
import { TrustRow } from "@/components/site/TrustRow";
import { Banners } from "@/components/site/Banners";
import { TunnelBanner } from "@/components/site/TunnelBanner";
import { VehiclesSection } from "@/components/site/VehiclesSection";

export default function HomePage() {
  const { hash } = useLocation();
  useEffect(() => {
    document.title = "Autovantis · Automotive Wholesale";
    if (hash) setTimeout(() => document.querySelector(hash)?.scrollIntoView(), 100);
  }, [hash]);
  return (
    <div className="bg-[#060A14] text-white">
      <Header />
      <main>
        <Hero />
        <TrustRow />
        <Banners />
        <VehiclesSection />
        <BrandMarquee />
        <About />
        <Offer />
        <Brands />
        <Why />
        <TunnelBanner />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
